import PropTypes from 'prop-types';
import {
  Backdrop,
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Typography,
} from '@material-ui/core';
import ConfirmationCard from 'common/components/cards/confirmationCard/confirmationCard';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import MaterialCard from 'common/components/cards/materialCard';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import 'primereact/resources/themes/nova/theme.css';
import { Column } from 'primereact/column';
import 'primereact/resources/primereact.css';
import MaterialGrid from '@material-ui/core/Grid';
import { ActionNameElement } from 'common/components/table/tableComponents';
import 'common/components/table/tableGeneral.css';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Engagement from 'assets/titlesMobile/engagement.svg';
import { getTemplates } from '../actions/actionsFile';
import {
  Delete,
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@material-ui/icons';
import { removeAccess, getLazyUser, getTotalNumberUser } from './contactsActions';
import * as XLSX from 'xlsx';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function GeneralActions(props) {
  const { auth } = props;
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [template, setTemplate] = useState({});
  const [item, setItem] = useState(null);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [finishDelete, setFinishDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [page, setPage] = useState(0);
  const [refresh, setRefresh] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openBulkDelete, setOpenBulkDelete] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [bulkMode, setBulkMode] = useState('deactivate');
  const [bulkFileName, setBulkFileName] = useState('');
  const [bulkDeleteIds, setBulkDeleteIds] = useState([]);
  const [bulkDeleteNotFound, setBulkDeleteNotFound] = useState([]);
  const [bulkFileRows, setBulkFileRows] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [bulkDeleteStep, setBulkDeleteStep] = useState('upload');
  const [bulkDeleteProgress, setBulkDeleteProgress] = useState(0);
  const bulkFileInputRef = useRef(null);
  const [bulkDeleteErrors, setBulkDeleteErrors] = useState([]);
  const [bulkFileError, setBulkFileError] = useState('');
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: {
      name: { value: '', matchMode: 'contains' },
    },
  });

  useEffect(() => {
    props.getTemplates(auth.user.establishments[0].id);
    setSelectedOption('online');
  }, [refresh]);

  useEffect(() => {
    if (selectedOption === 'online') {
      setTotalRecords(props.contacts?.userTotal?.total ?? 7000);
      setData(props.contacts.list.content);
    }
    setLoading(false);
  }, [props.contacts.list.content, refresh]);

  useEffect(() => {
    lazyState.first = 0;
    lazyState.page = 0;
    lazyState.rows = 10;
    setLoading(true);
    props.getTotalNumberUser(auth.user.establishments[0].stations[0].id, lazyState);
    props.getLazyUser(auth.user.establishments[0].stations[0].id, lazyState);
  }, [refresh]);

  useEffect(() => {
    setLoading(true);
    props.getLazyUser(auth.user.establishments[0].stations[0].id, lazyState);
    props.getTotalNumberUser(auth.user.establishments[0].stations[0].id, lazyState);
  }, [lazyState, refresh]);

  const useStyles = makeStyles({
    root: {
      display: 'contents',
      '& .p-datatable-tbody': {
        display: 'none',
      },
      '& .p-column-header-content': {
        display: 'none',
      },
    },
  });

  const classes = useStyles();
  function handleDelete(id, resolve, reject) {
    props.removeAccess(
      id,
      setFinishDelete,
      props.auth.user.establishments[0].stations[0].id,
      setOpenConfirmation
    );
    props.getLazyUser(auth.user.establishments[0].stations[0].id, lazyState);
    props.getTotalNumberUser(auth.user.establishments[0].stations[0].id, lazyState);
  }

  const processFile = (file) => {
    if (!file) return;
    setBulkFileError('');
    const ext = file.name.split('.').pop().toLowerCase();
    if (!['xlsx', 'xls', 'csv'].includes(ext)) {
      setBulkFileError(`Formato inválido: "${file.name}". Envie um arquivo .xlsx, .xls ou .csv.`);
      return;
    }
    setBulkFileName(file.name);
    const isCsv = ext === 'csv';
    const reader = new FileReader();
    reader.onload = (evt) => {
      const workbook = isCsv
        ? XLSX.read(evt.target.result, { type: 'string' })
        : XLSX.read(evt.target.result, { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const normalizeCpf = (v) =>
        String(v || '')
          .replace(/[.\-\s]/g, '')
          .trim();
      const normalizeName = (v) =>
        String(v || '')
          .trim()
          .toLowerCase();

      const excelRows = jsonData
        .map((row) => ({
          nome: normalizeName(row['Nome'] || row['nome'] || row['NOME'] || ''),
          nomeOriginal: row['Nome'] || row['nome'] || row['NOME'] || '',
          cpf: normalizeCpf(row['CPF'] || row['cpf'] || ''),
          cpfOriginal: row['CPF'] || row['cpf'] || '',
          email: row['Email'] || row['email'] || '',
          telefone: row['Telefone'] || row['telefone'] || '',
        }))
        .filter((r) => r.nome || r.cpf);

      const hasCpfCol = jsonData.length > 0 && jsonData.some((r) => r['CPF'] || r['cpf']);
      const hasNomeCol =
        jsonData.length > 0 && jsonData.some((r) => r['Nome'] || r['nome'] || r['NOME']);
      if (jsonData.length === 0) {
        setBulkFileError('O arquivo está vazio. Certifique-se de que há dados na planilha.');
        setBulkFileName('');
        return;
      }
      if (!hasCpfCol && !hasNomeCol) {
        setBulkFileError(
          'Colunas não encontradas. O arquivo deve ter pelo menos uma coluna "CPF" ou "Nome".'
        );
        setBulkFileName('');
        return;
      }
      if (excelRows.length === 0) {
        setBulkFileError(
          'Nenhum registro válido encontrado. Verifique se as linhas têm CPF ou Nome preenchidos.'
        );
        setBulkFileName('');
        return;
      }

      setBulkDeleteStep('resolving');

      axios
        .get(
          `${BASE_API}/users-station/?where[active]=1&&where[station_id]=${
            auth.user.establishments[0].stations[0].id
          }&&where[limit]=99999&&where[offset]=0&&where[order]=null null&&where[filters]=${JSON.stringify(
            { name: { value: '', matchMode: 'contains' } }
          )}`,
          {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
          }
        )
        .then((response) => {
          const allUsers = response.data || [];
          const resolvedIds = [];
          const notFound = [];
          const annotatedRows = [];

          excelRows.forEach((row) => {
            let match = null;

            // Busca prioritária por CPF
            if (row.cpf) {
              match = allUsers.find((u) => {
                const uCpf = normalizeCpf(u.cpf);
                return uCpf && uCpf === row.cpf;
              });
            }

            // Fallback por nome (somente se não achou por CPF)
            if (!match && row.nome) {
              match = allUsers.find((u) => normalizeName(u.name) === row.nome);
            }

            if (match) {
              // Aceita id, user_id, userId ou _id
              const userId = match.id ?? match.user_id ?? match.userId ?? match._id;
              if (userId !== undefined && userId !== null) {
                resolvedIds.push(userId);
                annotatedRows.push({ ...row, found: true, id: userId });
              } else {
                console.warn('[BulkDelete] Usuário encontrado mas sem ID:', match);
                notFound.push(row.cpfOriginal || row.nomeOriginal);
                annotatedRows.push({ ...row, found: false });
              }
            } else {
              notFound.push(row.cpfOriginal || row.nomeOriginal);
              annotatedRows.push({ ...row, found: false });
            }
          });

          setBulkFileRows(annotatedRows);
          setBulkDeleteIds(resolvedIds);
          setBulkDeleteNotFound(notFound);
          setBulkDeleteStep('confirm');
        })
        .catch((err) => {
          console.error('Erro ao buscar usuários:', err);
          setBulkDeleteStep('upload');
          setBulkFileName('');
        });
    };
    reader.onerror = () => {
      console.error('Erro ao ler arquivo');
      setBulkDeleteStep('upload');
      setBulkFileName('');
    };
    if (isCsv) {
      reader.readAsText(file, 'UTF-8');
    } else {
      reader.readAsBinaryString(file);
    }
    // Reseta o input após capturar o arquivo
    if (bulkFileInputRef.current) bulkFileInputRef.current.value = '';
  };

  const handleBulkDeleteFile = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const executeBulkAction = async () => {
    setBulkDeleteStep('progress');
    setBulkDeleteLoading(true);
    setBulkDeleteProgress(0);
    const results = await Promise.allSettled(
      bulkDeleteIds.map((id) =>
        axios.delete(`${BASE_API}/remove-user-access/${id}`, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        })
      )
    );
    const errors = results.reduce((acc, result, i) => {
      if (result.status === 'rejected') acc.push(bulkDeleteIds[i]);
      return acc;
    }, []);
    setBulkDeleteProgress(bulkDeleteIds.length);
    setBulkDeleteErrors(errors);
    setBulkDeleteLoading(false);
    setBulkDeleteStep('done');
    setRefresh((prev) => !prev);
  };

  const handleCloseBulkDelete = () => {
    setOpenBulkDelete(false);
    setBulkDeleteStep('upload');
    setBulkDeleteIds([]);
    setBulkDeleteNotFound([]);
    setBulkFileRows([]);
    setBulkFileName('');
    setBulkFileError('');
    setBulkDeleteErrors([]);
    setBulkDeleteProgress(0);
    if (bulkFileInputRef.current) bulkFileInputRef.current.value = '';
  };

  const renderEmptyCard = () => {
    return (
      <MaterialGrid item xs={12} md={3} style={{ marginBottom: 10 }}>
        <MaterialCard
          horizontalCard
          router={props.router}
          cardEmpty
          onClick={() => {
            props.router.push('/owner/acoes');
          }}
          name={'Galeria de Atividades'}
          image={``}
          type={''}
        />
      </MaterialGrid>
    );
  };

  const itemTemplate = (option) => {
    return (
      <div
        style={{
          paddingRight: '10px',
          paddingLeft: '10px',
        }}>
        {option.label}
      </div>
    );
  };

  const emailBodyTemplate = (rowData) => {
    return <span>{rowData['email']}</span>;
  };
  const telBodyTemplate = (rowData) => {
    return rowData.tel;
  };

  const createdAtBodyTemplate = (rowData) => {
    return rowData.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY') : '-';
  };

  const cpfBodyTemplate = (rowData) => {
    return <span>{rowData['cpf']}</span>;
  };

  const nameBodyTemplate = (rowData) => {
    return (
      <ActionNameElement
        className="p-column-filter"
        singleColum={false}
        actionName={rowData['name']}
      />
    );
  };

  const botaoAcaoDeletar = (rowData) => {
    return (
      <Tooltip title="Deletar">
        <IconButton
          aria-label="Deletar"
          style={{ backgroundColor: 'transparent' }}
          onClick={() => {
            setOpenConfirmation(true);
            setItem(rowData.id);
          }}>
          <Delete />
        </IconButton>
      </Tooltip>
    );
  };

  const gerarExcel = async () => {
    try {
      const response = await axios.get(
        `${BASE_API}/users-stations-light/${auth.user.establishments[0].stations[0].id}`,
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      );
      const rawData = response.data;
      // Verificação para garantir que há dados
      if (!rawData || rawData.length === 0) {
        console.warn('Não há dados para gerar o arquivo Excel.');
        return; // Interrompe a função aqui
      }
      const dadosParaPlanilha = rawData.map((item) => ({
        Nome: item.name || '',
        CPF: item.cpf || '',
        Email: item.email || '',
        Telefone: item.tel || '',
        'Data de Cadastro': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '',
      }));
      const livro = XLSX.utils.book_new();
      const planilha = XLSX.utils.json_to_sheet(dadosParaPlanilha);
      XLSX.utils.book_append_sheet(livro, planilha, 'Participantes');
      XLSX.writeFile(livro, 'Participantes.xlsx');
    } catch (error) {
      console.error('Ocorreu um erro!', error);
    }
  };

  const acoesBodyTemplate = (rowData) => {
    if (selectedOption === 'online') {
      return <div>{botaoAcaoDeletar(rowData)}</div>;
    }
  };

  const onFilter = (event) => {
    event['first'] = 0;
    setlazyState(event);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setlazyState((prevState) => ({
      ...prevState,
      first: newPage * rowsPerPage,
      page: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setlazyState((prevState) => ({
      ...prevState,
      first: 0,
      rows: newRowsPerPage,
    }));
  };

  const onPage = (event) => {
    setlazyState(event);
  };

  const isScheduled = (activity) => {
    if (activity.active && !activity.is_draft) {
      if (moment(new Date()).isBefore(activity.start)) return true;
    }
    return false;
  };

  const thStyle = {
    padding: '6px 10px',
    textAlign: 'left',
    fontWeight: 600,
    borderBottom: '1px solid #ddd',
  };
  const tdStyle = { padding: '5px 10px', borderBottom: '1px solid #eee' };

  const PaginationActions = ({ count, page: pg, rowsPerPage: rpp, onPageChange }) => (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <IconButton onClick={(e) => onPageChange(e, 0)} disabled={pg === 0}>
        <FirstPage />
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, pg - 1)} disabled={pg === 0}>
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={(e) => onPageChange(e, pg + 1)}
        disabled={pg >= Math.ceil(count / rpp) - 1}>
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rpp) - 1))}
        disabled={pg >= Math.ceil(count / rpp) - 1}>
        <LastPage />
      </IconButton>
    </Box>
  );

  return (
    <MaterialGrid
      container
      justifyContent="center"
      style={{
        maxWidth: '86vw',
        paddingBottom: '4rem',
      }}>
      <GenericConfirmationCard
        cancelClose={() => setOpenConfirmation(false)}
        open={openConfirmation}
        // state={props.contacts}
        loading={props.contacts.loading}
        general={props.general}
        title="Deletar Cadastro"
        confirmButtonColor={'primary'}
        text="Tem certeza que deseja remover esse cadastro?"
        onClose={() => setOpenConfirmation(false)}
        onClick={() => {
          if (item) handleDelete(item);
        }}
      />
      <GeneralGrid
        container
        justifyContent="center"
        spacing={2}
        style={{
          display: 'flex',
          marginBottom: 15,
          marginTop: 15,
        }}>
        {isMobile ? (
          <div className="d-flex justify-content-start align-items-center container-fluid">
            <div style={{ width: 23, height: 23 }}>
              <img src={Engagement} alt="engagement" style={{ width: 23, height: 'auto' }} />
            </div>
            <h4
              style={{
                fontSize: 20,
                fontWeight: 400,
                margin: 0,
                marginLeft: 15,
              }}>
              Engajamento
            </h4>
          </div>
        ) : null}
      </GeneralGrid>
      <MaterialGrid
        container
        style={{
          marginTop: isMobile ? 0 : 15,
          marginBottom: isMobile ? 0 : 15,
        }}>
        <div className={classes.root}>
          <DataTable
            value={data}
            lazy
            totalRecords={totalRecords}
            rows={lazyState.rows}
            rowsPerPageOptions={[10, 25, 50]}
            dataKey="id"
            scrollable
            loading={loading}
            first={lazyState.first}
            onFilter={onFilter}
            onPage={onPage}
            resizableColumns
            filterDisplay="row"
            filters={lazyState.filters}
            style={{ width: '100%' }}>
            <Column
              field="name"
              header="Nome"
              sortable
              filter
              filterPlaceholder="Pesquisar"
              style={{ minWidth: '14rem', minHeight: '45rem' }}></Column>
            <Column
              field="createdAt"
              header="Data de criação"
              body={createdAtBodyTemplate}
              sortable
              style={{ minWidth: '10rem' }}></Column>
          </DataTable>
        </div>
      </MaterialGrid>
      <MaterialGrid
        item
        xs={12}
        style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '16px 0' }}>
        <Button
          variant="contained"
          onClick={() => gerarExcel()}
          style={{ backgroundColor: '#4caf50', color: '#fff' }}
          startIcon={<FontAwesomeIcon icon={faBook} />}>
          Gerar Excel
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: '#ff9800', color: '#fff' }}
          onClick={() => {
            setBulkMode('deactivate');
            setBulkDeleteStep('upload');
            setBulkDeleteIds([]);
            setBulkDeleteNotFound([]);
            setBulkFileRows([]);
            setBulkDeleteErrors([]);
            setBulkDeleteProgress(0);
            setOpenBulkDelete(true);
          }}>
          Desativar Filiados
        </Button>
      </MaterialGrid>

      {/* Modal de Ação em Massa (Excluir / Desativar) */}
      <Dialog open={openBulkDelete} onClose={handleCloseBulkDelete} maxWidth="md" fullWidth>
        <DialogTitle>
          {bulkMode === 'deactivate' ? 'Desativar Filiados em Excel' : 'Excluir Cadastros em Massa'}
        </DialogTitle>
        <DialogContent dividers>
          {bulkDeleteStep === 'upload' && (
            <Box>
              <Typography variant="body2" gutterBottom>
                Faça o upload de um arquivo Excel (.xlsx) com as colunas <strong>Nome</strong> e/ou{' '}
                <strong>CPF</strong> dos cadastros a serem{' '}
                {bulkMode === 'deactivate' ? 'desativados' : 'excluídos'}.
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Dica: use o botão <strong>Gerar Excel</strong> para baixar a lista completa e remova
                as linhas que <em>não</em> devem ser afetadas.
              </Typography>
              {/* Input file oculto com ref */}
              <input
                ref={bulkFileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: 'none' }}
                onChange={handleBulkDeleteFile}
              />
              <Box
                mt={2}
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDragOver(false);
                  const file = e.dataTransfer.files && e.dataTransfer.files[0];
                  processFile(file);
                }}
                style={{
                  border: `2px dashed ${dragOver ? '#1976d2' : '#bdbdbd'}`,
                  borderRadius: 8,
                  padding: '32px 16px',
                  textAlign: 'center',
                  background: dragOver ? '#e3f2fd' : '#fafafa',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                }}>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {dragOver ? 'Solte o arquivo aqui' : 'Arraste e solte o arquivo aqui ou'}
                </Typography>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => bulkFileInputRef.current && bulkFileInputRef.current.click()}>
                  Selecionar Arquivo Excel
                </Button>
                {bulkFileName ? (
                  <Typography
                    variant="caption"
                    display="block"
                    style={{ marginTop: 8, color: '#2e7d32', fontWeight: 600 }}>
                    📎 {bulkFileName}
                  </Typography>
                ) : (
                  <Typography
                    variant="caption"
                    display="block"
                    color="textSecondary"
                    style={{ marginTop: 8 }}>
                    Formatos aceitos: .xlsx, .xls, .csv
                  </Typography>
                )}
              </Box>
              {bulkFileError && (
                <Box
                  mt={2}
                  p={1.5}
                  style={{ background: '#fff3e0', borderRadius: 6, border: '1px solid #ffb74d' }}>
                  <Typography variant="body2" color="error">
                    ⚠ {bulkFileError}
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          {bulkDeleteStep === 'resolving' && (
            <Box>
              <Typography variant="body2" gutterBottom>
                Buscando cadastros no sistema...
              </Typography>
              <LinearProgress />
            </Box>
          )}

          {bulkDeleteStep === 'confirm' && (
            <Box>
              <Typography variant="body1" gutterBottom>
                {bulkMode === 'deactivate'
                  ? 'Cadastros encontrados para desativar:'
                  : 'Cadastros encontrados para excluir:'}{' '}
                <strong>{bulkDeleteIds.length}</strong> de <strong>{bulkFileRows.length}</strong>
              </Typography>

              {/* Tabela de prévia do arquivo */}
              {bulkFileRows.length > 0 && (
                <Box mt={1} mb={2} style={{ maxHeight: 300, overflowY: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: '#f0f0f0' }}>
                        <th style={thStyle}>Nome</th>
                        <th style={thStyle}>CPF</th>
                        <th style={thStyle}>E-mail</th>
                        <th style={thStyle}>Telefone</th>
                        <th style={thStyle}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bulkFileRows.map((row, i) => (
                        <tr key={i} style={{ background: row.found ? '#e8f5e9' : '#fff3e0' }}>
                          <td style={tdStyle}>{row.nomeOriginal || '-'}</td>
                          <td style={tdStyle}>{row.cpfOriginal || '-'}</td>
                          <td style={tdStyle}>{row.email || '-'}</td>
                          <td style={tdStyle}>{row.telefone || '-'}</td>
                          <td
                            style={{
                              ...tdStyle,
                              fontWeight: 600,
                              color: row.found ? '#2e7d32' : '#e65100',
                            }}>
                            {row.found ? '✓ Encontrado' : '✗ Não encontrado'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              )}

              {bulkDeleteIds.length === 0 ? (
                <Typography variant="body2" color="error">
                  Nenhum cadastro correspondente foi encontrado.
                </Typography>
              ) : (
                <Typography variant="body2" color="error" style={{ marginTop: 4 }}>
                  {bulkMode === 'deactivate'
                    ? 'Os filiados encontrados serão desativados. Deseja continuar?'
                    : 'Essa ação é irreversível. Deseja continuar?'}
                </Typography>
              )}
            </Box>
          )}

          {bulkDeleteStep === 'progress' && (
            <Box>
              <Typography variant="body2" gutterBottom>
                {bulkMode === 'deactivate' ? 'Desativando' : 'Excluindo'} {bulkDeleteProgress} de{' '}
                {bulkDeleteIds.length}...
              </Typography>
              <LinearProgress
                variant="determinate"
                value={(bulkDeleteProgress / bulkDeleteIds.length) * 100}
              />
            </Box>
          )}

          {bulkDeleteStep === 'done' && (
            <Box>
              <Typography variant="body1" color="primary" gutterBottom>
                {bulkMode === 'deactivate' ? 'Desativação concluída!' : 'Exclusão concluída!'}
              </Typography>
              <Typography variant="body2">
                {bulkMode === 'deactivate' ? 'Desativados' : 'Excluídos'} com sucesso:{' '}
                <strong>{bulkDeleteIds.length - bulkDeleteErrors.length}</strong>
              </Typography>
              {bulkDeleteErrors.length > 0 && (
                <Typography variant="body2" color="error">
                  Falhas: <strong>{bulkDeleteErrors.length}</strong>
                </Typography>
              )}
              {bulkDeleteNotFound.length > 0 && (
                <Typography variant="body2" color="textSecondary">
                  Não encontrados no sistema: <strong>{bulkDeleteNotFound.length}</strong>
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {bulkDeleteStep !== 'progress' && bulkDeleteStep !== 'resolving' && (
            <Button onClick={handleCloseBulkDelete} color="default">
              {bulkDeleteStep === 'done' ? 'Fechar' : 'Cancelar'}
            </Button>
          )}
          {bulkDeleteStep === 'confirm' && bulkDeleteIds.length > 0 && (
            <Button
              onClick={executeBulkAction}
              variant="contained"
              style={{
                backgroundColor: bulkMode === 'deactivate' ? '#ff9800' : undefined,
                color: bulkMode === 'deactivate' ? '#fff' : undefined,
              }}
              color={bulkMode === 'deactivate' ? undefined : 'secondary'}>
              {bulkMode === 'deactivate' ? 'Confirmar Desativação' : 'Confirmar Exclusão'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>CPF</TableCell>
                <TableCell>E-mail</TableCell>
                <TableCell>Telefone</TableCell>
                <TableCell>Data de Cadastro</TableCell>
                <TableCell>Excluir</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{nameBodyTemplate(row)}</TableCell>
                  <TableCell>{cpfBodyTemplate(row)}</TableCell>
                  <TableCell>{emailBodyTemplate(row)}</TableCell>
                  <TableCell>{telBodyTemplate(row)}</TableCell>
                  <TableCell>{createdAtBodyTemplate(row)}</TableCell>
                  <TableCell>{acoesBodyTemplate(row)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Linhas por página"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
            ActionsComponent={PaginationActions}
          />
        </TableContainer>
      </>
      <ConfirmationCard
        onClose={() => setOpen(false)}
        open={open}
        item={template.id}
        station_id={props.auth.user.establishments[0].stations[0].id}
        partner_id={null}
        sponsored={null}
        router={props.router}
      />
    </MaterialGrid>
  );
}

GeneralActions.propTypes = {
  actions: PropTypes.shape({
    templatesList: PropTypes.shape({
      filter: PropTypes.func,
      length: PropTypes.number,
    }),
    templatesLoading: PropTypes.any,
  }),
  getLazyUser: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      first_time: PropTypes.any,
    }),
  }),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  getLazyStationActiveActions: PropTypes.func,
  getTemplates: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      to: PropTypes.any,
    }),
  }),
};

const mapStateToProps = (state) => {
  return {
    userTotal: state.contacts.userTotal,
    auth: state.auth,
    general: state.general,
    contacts: state.contacts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getLazyUser,
      getTotalNumberUser,
      removeAccess,
      getTemplates,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralActions);
